<template>
	<div class="page">
		<div class="top_box">
			<div class="top_line">请选择你的性别</div>
			<p>即将为你推荐优质的异性</p>
		</div>
		<div class="sex_box">
			<li class="sex_line" @click="selectSex(item.value)" v-for="item in sexList" :key="item.label">
				<img src='../../assets/img/男.png' v-if="item.value == 0" />
				<img src='../../assets/img/女.png' v-if="item.value == 1" />
				<div class="out_sex" :class="item.active">
					<label>{{item.label}}</label>
				</div>
			</li>
			<!-- <div class="sex_line" @click="selectSex('女生')">
				<image src='../../static/img/0.png'></image>
				<div class="out_sex">
					<u-icon name="checkmark-circle-fill" color="#B2B2B2" size="40"></u-icon>
					<text>女生</text>
				</div>
			</div> -->
		</div>
		<div class="tips">注意：注册成功后性别不可修改</div>
		<div class="next_step_btn">
			<div class="customStyle" @click="nextStep">下一步</div>
		</div>
	</div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
	export default{
		data(){
			return{
				chosedSex:'',
				sexList:[{
					label:'男生',
					color:'#2979ff',
					active:'',
					value:'0'
				},{
					label:'女生',
					color:'#B2B2B2',
					active:'',
					value:'1'
				},],
				userInfo:[],
			}
		},
		mounted() {
			localStorage.clear();
			this.$store.commit('clear_message', '');
		},
		methods:{
			...mapMutations(["get", "post"]), //引入方法
			selectSex(val){
				this.userInfo.sex = val
				if(val == 0){
					this.sexList[0].color = '#2979ff';
					this.sexList[0].active = 'active_man';
					this.sexList[1].color = '#B2B2B2';
					this.sexList[1].active = '';
					this.chosedSex = '男生';
				}else{
					this.sexList[1].color = '#DD93CD';
					this.sexList[1].active = 'active_woman';
					this.sexList[0].color = '#B2B2B2';
					this.sexList[0].active = '';
					this.chosedSex = '女生';
				}
			},
			nextStep(){
				if(this.chosedSex == ''){
					this.$toast.center("请选择性别~");
					return false;
				}else{
					this.$router.push({ name: "reg_age",params: { sex: this.chosedSex } });
				}
			},
			
			
		}
	}
</script>

<style lang="scss" scoped>
	.page{
		padding-top:5rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		color:#333;
		font-size: 1rem;
		.top_box{
			.top_line{
				text-align: center;
				font-weight: 600;
				padding-bottom: 1rem;
			}
			.top_line:before,.top_line:after{
				content: " ";
				display: inline-block;
				width: .5rem;
				height:.5rem;
				border-radius: 50%;
				background: linear-gradient(to right, #af5ee8, #f5aebf);
				margin:0 1rem 0 0;
				vertical-align: middle;
			}
			.top_line:after{
				margin:0 0 0 1rem;
			}
			p{
				font-size: 1rem;
				color: #666;
			}
		}
		.sex_box{
			display: flex;
			justify-content: space-around;
			width: 70%;
			padding-top:3rem;
			.sex_line{
				display: flex;
				flex-direction: column;
				align-items: center;
				img{
					width: 8rem;
					height: 8rem;
					border-radius: 1rem;

				}
				.out_sex{
					display: flex;
					align-items: center;
					margin-top:1.2rem;
					height:2rem;
					line-height: 2rem;
					padding:.3rem 2rem;
					border-radius: 2rem;
					border:2px solid #B2B2B2;
					lable{
						padding-left: 1rem;
						font-size: 1rem;
					}
				}
				.active_man{
					border:2px solid #2979ff;
                    background: #2979ff;
					color: #fff;
					
				}
				.active_woman{
					border:2px solid #e640c2;
                    background: #e640c2;
					color: #fff;
				}
			}
		}
		.tips {
			padding-top: 2em;
			color:#666;
		}
		.next_step_btn{
			width: 70%;
			margin-top: 5rem;
            .customStyle{
					border:none;
					background: linear-gradient(to right, #af5ee8, #f5aebf);
					box-shadow:0px 0px 20px #ECECEC;
                    
                    height: 3rem;
                    line-height: 3rem;
                    border-radius: 2rem;
					color:#ffff;
                    text-align: center;
				}
		}
	}
</style>

